<!-- <a
  class="btn btn-outline-primary"
  href="#"
  [routerLink]="['/','bot-admin', 'project', this.permissionService.selectedProjectId]"
  i18n="@@back-to-project-view"
>Zurück zum Projekt-Übersicht</a> -->
<div class="d-flex align-items-center">
  <h3
    class="mt-2"
    i18n="@@project-groups"
  >Projektgruppen</h3>
  <p-button
    type="button"
    severity="primary"
    [rounded]="true"
    styleClass="p-0 ms-2"
    [style]="{'width': '30px', 'height': '30px'}"
    icon="ri-add-large-fill"
    (onClick)="this.openAddModal('group')"
  ></p-button>
</div>
<p-table
  [value]="this.permissionService.projectGroups"
  styleClass="p-datatable-sm"
  [rowHover]="true"
>
  <ng-template
    pTemplate="body"
    let-projectGroup
  >
    <tr>
      <td
        style="vertical-align: middle;"
        class="w-75"
      >
        <p-button
          [text]="true"
          styleClass="p-0 text-decoration-underline"
          [label]="projectGroup.name"
          (onClick)="this.openEditModal(projectGroup._id)"
        ></p-button>
      </td>
      <td
        style="vertical-align: middle;"
        class="pe-2 text-end"
      >
        <p-button
          [text]="true"
          severity="danger"
          icon="ri-delete-bin-line"
          (onClick)="this.permissionService.removeGroupsFromProject([projectGroup._id])"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<div class="d-flex align-items-center">
  <h3
    class="mt-2"
    i18n="@@project-user"
  >Projektnutzer</h3>
  <p-button
    type="button"
    severity="primary"
    [rounded]="true"
    styleClass="p-0 ms-2"
    [style]="{'width': '30px', 'height': '30px'}"
    icon="ri-add-large-fill"
    (onClick)="this.openAddModal('user')"
  ></p-button>
</div>
<p-table
  [value]="this.permissionService.projectUsers"
  styleClass="p-datatable-sm"
  [rowHover]="true"
>
  <ng-template
    pTemplate="body"
    let-projectUser
  >
    <tr>
      <td
        style="vertical-align: middle;"
        class="w-75"
      >
        {{projectUser.name}}
      </td>
      <td
        style="vertical-align: middle;"
        class="pe-2 text-end"
      >
        <p-button
          [text]="true"
          severity="danger"
          icon="ri-delete-bin-line"
          (onClick)="this.permissionService.removeUsersFromProject([projectUser.userId])"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>